import { create } from 'zustand'

interface UserState {
    adminId: bigint | null
    setAdminId: (adminId: bigint) => void
}

export const useAdminId = create<UserState>((set) => ({
    adminId: null,
    setAdminId: (adminId) =>
        set({ adminId }),
}))
